import * as React from 'react';

import {CTABanner} from 'shells/cta-banner/cta-banner';
// @ts-expect-error - imported from .js/.jsx file
import {StageIcon} from 'shells/icon/svg/stage-icon';

import {useDismissibleUserSetting, useShouldShowWizard} from '../../../../util/hooks';

import styles from './default-pipeline-edit-cta.module.css';

type Props = {
    completedWizardKey: string;
    dismissKey: string;
};

export function DefaultPipelineEditCTA(props: Props) {
    const {shouldShow} = useShouldShowWizard(props.completedWizardKey);
    const {shouldShow: isNotDismissed, onDismiss} = useDismissibleUserSetting(props.dismissKey);
    const handleDismiss = () => {
        if (onDismiss) {
            onDismiss();
        }
    };

    return shouldShow && isNotDismissed ? (
        <div id='for-intercom-not-your-stages' className={styles.cta}>
            <CTABanner
                icon={StageIcon}
                buttonText='Get started'
                text='Not the stages that work for you? Let Nutshell help you design your sales process. Define stages, goals, automated tasks, and more!'
                href='/setup/sales-automation?wizard=true'
                // @ts-expect-error
                onDismiss={handleDismiss}
            />
        </div>
    ) : null;
}
